import type {ReactElement} from 'react';
import type {BrandKitSwatchClusterProps} from './brand-kit-swatch-cluster.types';
import styles from './brand-kit-swatch-cluster.module.scss';

/** The mini cluster that stands for a kit: its first logo, then its first colours, overlapping. The logo leads and paints on top. */
export function BrandKitSwatchCluster({cluster, className = ''}: BrandKitSwatchClusterProps): ReactElement | null {
  if (cluster.logoSrc === null && cluster.hexCodes.length === 0) {
    return null;
  }

  const getLogoSwatch = (): ReactElement | null => {
    if (cluster.logoSrc === null) {
      return null;
    }

    return <img className={`${styles.swatch} ${styles.logoSwatch} corner-radius-full _position-relative`} src={cluster.logoSrc} alt="" />;
  };

  return (
    <span className={`${styles.swatchCluster} flexbox ${className}`} aria-hidden="true">
      {getLogoSwatch()}
      {cluster.hexCodes.map((hexCode) => {
        return <span key={hexCode} className={`${styles.swatch} corner-radius-full _position-relative`} style={{backgroundColor: hexCode}} />;
      })}
    </span>
  );
}
